import { useMemo } from 'react';
import { Select, type SelectProps } from '@mantine/core';
import { useSites } from '../api';

interface SiteSelectProps extends Omit<SelectProps, 'data' | 'value' | 'onChange' | 'searchable'> {
  value: string;
  onChange: (siteId: string) => void;
}

/** Tenant has just a handful of sites (Sabie, later Howick) — fetched in full, no
 * typeahead needed. */
export function SiteSelect({ value, onChange, ...rest }: SiteSelectProps) {
  const { data, isLoading } = useSites();
  const options = useMemo(() => (data?.items ?? []).map((s) => ({ value: s.id, label: `${s.code} — ${s.name}` })), [data]);

  return (
    <Select
      {...rest}
      data={options}
      value={value || null}
      onChange={(newValue) => onChange(newValue ?? '')}
      placeholder={rest.placeholder ?? 'Choose a site…'}
      nothingFoundMessage={isLoading ? 'Loading…' : 'No sites found'}
      comboboxProps={{ withinPortal: true }}
    />
  );
}
